import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setStep } from '../step/stepSlice';

import Card from '../../components/Card';
import NetworkSelect from './NetworkSelect';
import BaseButton from '../../components/BaseButton';
import { steps } from '../step/stepSlice';

export default function ReceiverNetwork() {
  const { networks, selected } = useSelector((state) => state.networks);
  const dispatch = useDispatch();

  const handleNext = () => dispatch(setStep(steps.selectAmount));

  return (
    <Card step={steps.receiverNetwork} title="On" CollapsedContent={CollapsedContent}>
      <div className="network">
        {networks.length === 1 ? (
          <div className="single-network">
            {selected && !selected.logoLink ? (
              <div>{selected.name}</div>
            ) : (
              <img src={selected?.logoLink} alt={selected.name} />
            )}
          </div>
        ) : (
          <Fragment>
            <NetworkSelect />
            <div className="note">
              This information is filled in automatically, but you can change it if you need to
            </div>
          </Fragment>
        )}
        <BaseButton onClick={handleNext}>Next</BaseButton>
      </div>
    </Card>
  );
}

function CollapsedContent() {
  const { selected } = useSelector((state) => state.networks);

  return (
    <div className="collapsed-content">
      <div className="content selected-network">
        {!selected?.logoLink ? (
          <div>{selected.name}</div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={selected.logoLink} alt={selected.name} />
            <div style={{ marginLeft: '16px' }}>{selected.name}</div>
          </div>
        )}
      </div>
    </div>
  );
}
